import { handleActions } from 'redux-actions';
import {
  featureFlagsLoading,
  featureFlagsLoaded,
  featureFlagsError,
} from 'store/actions/feature-info-actions';
import { FeatureFlags } from 'models/api/feature-flags-model';

export default handleActions(
  {
    [featureFlagsLoading]: (featureFlags) => {
      return featureFlags.setLoading();
    },
    [featureFlagsLoaded]: (featureFlags, { payload }) => {
      return featureFlags.setLoaded(payload);
    },
    [featureFlagsError]: (featureFlags, { payload }) => {
      return featureFlags.setError(payload);
    },
  },
  new FeatureFlags(),
);
